"use client"
import { useSyncExternalStore } from "react"
const subscribe = () => () => undefined
const clientSnapshot = () => true
const serverSnapshot = () => false
export function useHydrated() {
  return useSyncExternalStore(subscribe, clientSnapshot, serverSnapshot)
}
